import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Condition } from 'Component/others';
import { TextBold, TextRegular } from 'UiKit/typography';
import SkeletonComponent from 'UiKit/skeleton';

import { useHostStreamState } from 'View/host-stream/state';

import styles from './styles.module.css';

const LivestreamBanner = ({ isLivestreaming, streamNumber, isControlView = false }) => {
  const { t } = useTranslation('host-stream');
  const { state } = useHostStreamState();

  const bannerText = isLivestreaming ? t('end_livestream') : t('start_livestream');
  const liveNumber = isLivestreaming ? streamNumber : streamNumber + 1;

  const bannerHeight = isControlView ? '50px' : state?.currentStep >= 2 ? '66px' : '90px';

  return (
    <Box className={styles['livestream-banner__container']} style={{ height: bannerHeight }}>
      <Condition
        statement={streamNumber !== undefined}
        fallback={
          <Flex width="100%" justifyItems="center" alignItems="center" flexDirection="column" gap="4px">
            <SkeletonComponent width="15%" height="var(--font-heading7)" />
            <SkeletonComponent width="30%" height="var(--font-heading7)" />
          </Flex>
        }
      >
        <Condition statement={!isControlView}>
          <TextRegular fontSize="var(--font-body3)">{bannerText}</TextRegular>
        </Condition>
        <TextBold fontSize="var(--font-heading7)">{t('live_number', { number: liveNumber })}</TextBold>
      </Condition>
    </Box>
  );
};

export default LivestreamBanner;
